// (function () {
//     'use strict';

//     const module = angular.module('imApp');

//     module.component('deviationTypes', {
//         templateUrl: 'views/components/views/deviationTypes/deviationTypes.template.html?v=' + module.version,
//         controllerAs: 'vm',
//         controller: ['$stateParams', 'stateService', 'utilityService', 'deviationTypesService', 'layoutService', function ($stateParams, stateService, utilityService, deviationTypesService, layoutService) {
//             const vm = this;
//             let activityTypeNo = $stateParams.activitytype_no;
			
//             vm.model = {
//                 tabletSize: layoutService.getMediaQueries().tablet,
//                 setting: {},
//                 itemsListDeviationTypes: []
//             };

//             async function loadSetting() {
//                 vm.model.setting = (await deviationTypesService.getSetting({ activitytype_no: activityTypeNo }))[0];
//             }
            
//             async function loadDeviationTypes() {
//                 if (utilityService.validateParmsValue(vm.model.setting.activitytype_no, true) !== true) return; 

//                 return vm.model.itemsListDeviationTypes = await deviationTypesService.listDeviationTypes({
//                     isactive: 'ALL',
//                     activitytype_no: vm.model.setting.activitytype_no
//                 });
//             }
            
//             vm.goToFunc = function (state, e) {
//                 function go(parms) {
//                     if (e?.ctrlKey) {
//                         stateService.newTab(state, parms);
//                     } else {
//                         stateService.go(state, parms);
//                     }
//                 }

//                 switch (state) {
//                     case 'deviationtype':
//                         go({ deviationtype_keyno: '0' });
//                         break;
//                     default:
//                         break;
//                 }
//             };
            
//             vm.onChanged = function (value, id) {
//                 switch (id) {
//                     case 'show_all':
//                         if (utilityService.validateWatchValue(value, vm.model.setting.show_all) !== true) return;

//                         vm.model.setting.show_all = value;

//                         if (utilityService.validateParmsValue(vm.model.setting.show_all, true) !== true) return;

//                         if (vm.model.setting.show_all === '1') {
//                             vm.model.setting.activitytype_no = '0';

//                             loadDeviationTypes();
//                         } else {
//                             vm.model.setting.activitytype_no = activityTypeNo;

//                             loadDeviationTypes();
//                         }
//                         break;
//                     default:
//                         utilityService.setValueToVariable(value);
//                         break;
//                 }
//             };
            
//             vm.$onInit = async function () {
//                 await loadSetting();
//                 loadDeviationTypes();
//             }
//         }]
//     });
// })();
